import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'channelId',
      type: 'select',
      label: '直播间',
      placeholder: '请选择直播间',
      clearable: true
    },
    {
      field: 'consumerNickName',
      type: 'input',
      label: '客户昵称',
      placeholder: '请输入客户昵称'
    },
    {
      field: 'duration',
      type: 'select',
      label: '观看时长',
      clearable: true,
      options: [
        { title: '全部', value: '' },
        { title: '≥ 5分钟', value: '300' },
        { title: '≥ 10分钟', value: '600' },
        { title: '≥ 20分钟', value: '1200' },
        { title: '≥ 25分钟', value: '1500' },
        { title: '≥ 30分钟', value: '1800' },
        { title: '≥ 40分钟', value: '2400' },
        { title: '≥ 50分钟', value: '3000' },
        { title: '≥ 60分钟', value: '3600' }
      ]
    },
    {
      field: 'accessTime',
      type: 'dateTimePicker',
      label: '直播时间段',
      clearable: false,
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    },
    {
      field: 'deptId',
      type: 'select',
      label: '部门',
      placeholder: '请选择部门',
      clearable: true
    },
    {
      field: 'empIds',
      type: 'select',
      label: '员工',
      clearable: true,
      filterable: true,
      placeholder: '请选择员工'
    }
  ]
}
